"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var nylas_connection_1 = __importDefault(require("../nylas-connection"));
var RestfulModelInstance = /** @class */ (function () {
    function RestfulModelInstance(modelClass, connection) {
        this.modelClass = modelClass;
        this.connection = connection;
        if (!(this.connection instanceof nylas_connection_1.default)) {
            throw new Error('Connection object not provided');
        }
        if (!this.modelClass) {
            throw new Error('Model class not provided');
        }
    }
    RestfulModelInstance.prototype.path = function () {
        return "/" + this.modelClass.endpointName;
    };
    RestfulModelInstance.prototype.get = function (params) {
        var _this = this;
        if (params === void 0) { params = {}; }
        return this.connection
            .request({
            method: 'GET',
            path: this.path(),
            qs: params,
        })
            .then(function (json) {
            var model = new _this.modelClass(_this.connection).fromJSON(json);
            return Promise.resolve(model);
        });
    };
    return RestfulModelInstance;
}());
exports.default = RestfulModelInstance;
